import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useViewport } from 'components/templates/viewportProvider';
import RenderSEO from 'components/atoms/renderSEO';
import thankYouImage from 'assets/images/Thank You-1.jpg';
import thankYouMobileImage from 'assets/images/Thank You-1-mob.jpg';
import { CallToAction } from 'components/atoms/callToAction';
import { RouteNames } from 'router';
import AddToCalendar from 'react-add-to-calendar';
import moment from 'moment';
import api from 'apiClient/api';
import { DateUtil } from 'utils/DateUtil';
import { infoLog } from 'loggers/logger';

const calendarItems = [
  { google: 'Google' },
  { outlookcom: 'Outlook.com' },
  { yahoo: 'Yahoo' }
];
const calendarButtonTemplate = { 'calendar-plus-o': 'left' };

const PaymentConfirmation = props => {
  const { isMobile } = useViewport();
  const [calendarEvent, setCalendarEvent] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const orderId = params.get('order_id');
    if (!orderId) return;

    infoLog('MUSIC_EVENT_BOOKING_SUCCESSFULL', {
      order_id: orderId,
      page: 'paymentConfirmation',
    });

    api
      .post(`getOrderForMusicEventId.json`, { order_id: orderId })
      .then(res => {
        if (res.data.status !== 'success') return;
        const { eventDetails } = res.data.data;
        const { music_event_date } = eventDetails;
        const { music_event_venue } = music_event_date;

        const title = music_event_venue.music_event_detail.event_name;
        const rawDescription = music_event_venue.music_event_detail.event_description;
        const location = [
          music_event_venue.restaurant_outlet.outlet_name,
          music_event_venue.area.area_name,
          music_event_venue.city.city_name,
        ].join(', ');

        const concertDate = DateUtil.getFullDateString(music_event_date?.concert_date);
        const start = moment(`${concertDate} ${music_event_date?.start_time}`, 'YYYY-MM-DD h:mm A').toDate();
        const end = moment(`${concertDate} ${music_event_date?.end_time}`, 'YYYY-MM-DD h:mm A').toDate();
        const plainDescription = rawDescription ? rawDescription.replace(/<[^>]*>/g, '').trim() : `You have successfully booked tickets for ${title}.`;

        setCalendarEvent({
          title,
          description: plainDescription,
          location,
          startTime: start,
          endTime: end,
        });
      })
      .catch(() => {});
  }, []);

  const metaTagSEO = {
    metaTitle: 'Total Environment | Apartments | Villas | India',
    metaDescription:
      'With an innate drive to create enhanced living experience for people, Total Environment designs apartments, penthouses and villas that people actually want to live in. From live music to handcrafted furniture to fine craft beer, we leave our mark of excellence everywhere. To know more about our homes and handcrafted experiences, call + 91 99000 78000.',
    metaKeywords: '',
  };

  const logoClass = isMobile ? 'thank-you-page-mobile' : 'thank-you-page';

  const handleClick = () => {
    props.history.push(RouteNames.musicEvents);
  };

  const handleLogoClick = () => {
    props.history.push('/');
  };

  return (
    <>
      <RenderSEO metaTags={metaTagSEO} currentRouteName={'homes'} />
      <div className={`section error-page ${isMobile ? 'mobile' : ''}`}>
        {isMobile ? (
          <img
            src={thankYouMobileImage}
            alt={'Background'}
            className={'background'}
          />
        ) : (
          <img
            src={thankYouImage}
            alt={'Background'}
            className={'background'}
          />
        )}
        <div className={'section-header'}>
          <div
            className={`logo-container ${logoClass}`}
            onClick={handleLogoClick}
          >
            <strong>Total</strong>Environment
          </div>
        </div>
        <div className={'section-container'}>
          {isMobile ? (
            <h2 className={'thank-you-heading'} style={{ textAlign: 'center' }}>
              Thank you for booking.
            </h2>
          ) : (
            <h1 className={'thank-you-heading'} style={{ textAlign: 'center' }}>
              Thank you for booking.
            </h1>
          )}
          <h3>Ticket Booked Successfully.</h3>
          <div className={'confirmation-actions'}>
            <CallToAction
              text={'Go back to events'}
              onClick={handleClick}
              mode={'transparent'}
              type={'link'}
              isMobile={true}
            />
            {calendarEvent && (
              <div className={'add-to-calendar-container'}>
                <AddToCalendar
                  event={calendarEvent}
                  listItems={calendarItems}
                  buttonLabel={'Add to Calendar'}
                  buttonTemplate={calendarButtonTemplate}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(PaymentConfirmation);
